// TODO [TM]: Uniforma le dimensioni con lo spinner dell'overlay
const LoadingSpinner = () => {
  return (
    <div className="grid justify-center items-center h-full">
      <div className="w-[60px] h-[60px] border-[3px] border-solid border-primary border-t-transparent rounded-full animate-spinner"></div>
    </div>
  )
}

export default LoadingSpinner
